import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IStandingDataTableRowFormMeta {
  control: FormInputMeta,
  action: FormInputMeta,
  actionVIP1: FormInputMeta,
  actionVIP2: FormInputMeta,
  //
  schema: any,
}

const StandingDataTableRowFormMeta = {} as IStandingDataTableRowFormMeta;

StandingDataTableRowFormMeta.control = {
  name: 'control',
  type: 'select',
  label: 'Contrôle',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
StandingDataTableRowFormMeta.action = {
  name: 'action',
  type: 'select',
  label: 'Action',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
StandingDataTableRowFormMeta.actionVIP1 = {
  name: 'actionVIP1',
  type: 'select',
  label: 'Action VIP1',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
StandingDataTableRowFormMeta.actionVIP2 = {
  name: 'actionVIP2',
  type: 'select',
  label: 'Action VIP2',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};

StandingDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(StandingDataTableRowFormMeta));

export default StandingDataTableRowFormMeta;
